import {
  ApiResponse,
  ZipCoverageDownloadResponse,
  ZipCoverageUIResponse,
} from "../../models/ApiResponse";
import {
  AddZipCoverageRequest,
  UpdateZipCoverageRequest,
} from "../../models/requestModels/zipCoverageRequest";
import { ZipCoverageResponse } from "../../models/responseModels/zipCoverageResponse";
import { axiosRequests } from "../axiosRequest";

export const ZipCoverageAgent = {
  getZipCoverageList: () =>
    axiosRequests.get<ZipCoverageUIResponse>("/zipCoverage/GetZipCoverageList"),
  zipCoverageCsvDownload: (zipCoverageData: ZipCoverageResponse[]) =>
    axiosRequests.post<ZipCoverageDownloadResponse>(
      "/zipCoverage/DownloadCsv",
      zipCoverageData
    ),
  zipCoverageXlsxDownload: (zipCoverageData: ZipCoverageResponse[]) =>
    axiosRequests.postXlsx<Blob>("/zipCoverage/DownloadXlsx", zipCoverageData),
  updateZipCoverage: (zipCoverageData: UpdateZipCoverageRequest) =>
    axiosRequests.post<ApiResponse>(
      "/zipCoverage/updateZipCoverage",
      zipCoverageData
    ),
  deleteZipCoverage: (zipCoverageData: UpdateZipCoverageRequest) =>
    axiosRequests.post<ApiResponse>(
      "/zipCoverage/deleteZipCoverage",
      zipCoverageData
    ),
  addZipCoverage: (zipCoverageData: AddZipCoverageRequest) =>
    axiosRequests.post<ApiResponse>(
      "/zipCoverage/addZipCoverage",
      zipCoverageData
    ),
};
